module.exports = __webpack_public_path__ + "static/media/3-1.0551d480.png";